import React,  { useState }  from "react";
import AbsoluteWrapper from "./AbsoluteWrapper";
import { NavLink, Link } from "react-router-dom";
import { Auth }  from 'aws-amplify';
//import Amplify from 'aws-amplify';
import { fetchAuthSession } from "aws-amplify";
//import { fetchAuthSession } from "aws-amplify/auth";
import { resendSignUpCode } from "aws-amplify";

import  emailjs from "@emailjs/browser";

import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails
} from  "amazon-cognito-identity-js";


import Login from "./Login";



//_______________________________________

/*var AWS = require("aws-sdk");

let awsConfig = {
    "region": "us-west-2",
    "endpoint": "http://dynamodb.us-west-2.amazonaws.com",
    "accessKeyId": "AKIAIOONJEQOVX5MSMHA", "secretAccessKey": "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"
};

AWS.config.update(awsConfig);

let docClient = new AWS.DynamoDB.DocumentClient();*/





     class PageThree extends React.Component {

            constructor(props)
            {
                super(props);

                this.state = {

                    email:'',

                    password:''

                };


                this.state = {
                preferences: {
                    Forex: false,
                    indices: false,
                    Commodities: false,
                    Stocks: false,
                    CFDs: false,
                    Cryptocurrency: false
                }
                };


            }


      

          state = {
                                username: "",
                                password: "",
                                firstName: "" ,
                                lastName: "" ,
                                submitted: false,
                                isAuthenticated : false,
                                showing : false,

                                userProfile : "",

                                LinkedIn : "",
                                experience: "",
                                platform: "",  
                                style : "",
                                market : "",
                                betaReason :"",

                                errors: {} ,

                                preferences: {},

                                feedback : false,
                             
                                preferences: {
                                    Forex: false,
                                    Indices: false,
                                    Commodities: false,
                                    Stocks: false,
                                    CFDs: false,
                                    Cryptocurrency: false
                                },

                                //==========================

                                email: '',

                                fullName: '',

                                given_name: '',

                                family_name: '',

                                password: '',

                                country: '',

                                verificationCode: '',

                                step: 'login',

                                loading: false,

                                message: '' ,

                                trialEnd : new Date(),

                                status : "" ,

                                userData : {},

                                //========================

                  };




    handleSubmit = async event => {
      event.preventDefault();
      //console.log('spinner is showing: ' + this.state.showing);
    };

//----------------------------------
//----------------------------------
   handleChange(e)
{
   this.setState({

      [e.target.name]: e.target.value

   });
}

//----------------------------------
//----------------------------------
async  load() {
  const session = await fetchAuthSession();
  console.log(session);
}




//----------------------------------
//----------------------------------
async requestAccess() {


  if (!this.validateForm()) return;

  try {

    this.setState({ errors: {} });

    const response = await Auth.signUp({

      username : this.state.email,
      password : this.state.password,

      attributes: {

        email                : this.state.email,
        preferred_username   : this.state.username,
        family_name          : this.state.lastName,
        given_name           : this.state.firstName,
        "custom:country"     : this.state.country,

      }
    });

    //console.log(response);

    this.setState({ step: "verify" });

    //this.setState({status : "FreeTrial"}) ;

  } catch (err) {
    console.log(err);

    let errors = {};

    switch (err.code) {
      case "UsernameExistsException":
      {
        errors.email = "This email already exists";
        //-----------------
        try {

            await Auth.resendSignUp(this.state.email);

            this.setState({
                step: "verify",
                errors: {
                server: "Your account already exists but is not confirmed. A new code has been sent."
                }
            });

            } catch (resendError) {
                this.setState({
                errors: { server: resendError.message }
            });
         }

         break;
       }

      case "InvalidPasswordException":
        errors.password = err.message;
        break;

      case "InvalidParameterException":
        errors.server = err.message;
        break;

      default:
        errors.server = err.message;
    }

    this.setState({ errors });

  }


}



validateForm = () => {
    let errors = {};

    const selectedMarkets = Object.values(this.state.preferences || {}).some(
    (value) => value === true
    );

    if (!selectedMarkets) {
         errors.preferences = "Select at least one market";
    }
    if (!(this.state.username || "").trim())
        errors.username = "Username is required";

    if (!(this.state.email || "").trim()) {
        errors.email = "Email is required";
    } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(this.state.email)) {
            errors.email = "Enter a valid email";
        }
    }

    if (!(this.state.firstName || "").trim())
        errors.firstName = "First name is required";

    if (!(this.state.lastName || "").trim())
        errors.lastName = "Last name is required";

    if (!(this.state.country || "").trim())
        errors.country = "Country is required";

    if (!(this.state.password || "").trim()) {
        errors.password = "Password is required";
    } else if (this.state.password.length < 8) {
        errors.password = "Minimum 8 characters";
    } else if (!/[A-Z]/.test(this.state.password)) {
        errors.password = "Must contain one uppercase letter";
    } else if (!/[a-z]/.test(this.state.password)) {
        errors.password = "Must contain one lowercase letter";
    } else if (!/[0-9]/.test(this.state.password)) {
        errors.password = "Must contain one number";
    }

    if (!(this.state.experience || "").trim())
        errors.experience = "Experience is required";

    if (!(this.state.platform || "").trim())
        errors.platform = "Platform is required";

    if (!(this.state.style || "").trim())
        errors.style = "Trading style is required";

    if (!(this.state.betaReason || "").trim())
        errors.betaReason = "Reason is required";

    this.setState({ errors });

    return Object.keys(errors).length === 0;
};


dev_validateForm = () => {
  let errors = {};

  if (!this.state.username.trim())
    errors.username = "Username is required";


  if (!(this.state.email || "").trim()) {
    errors.email = "Email is required";
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(this.state.email)) {
        errors.email = "Enter a valid email address";
    }
  }

  if (!this.state.firstName.trim())
    errors.firstName = "First name is required";

  if (!this.state.lastName.trim())
    errors.lastName = "Last name is required"; //verificationCode

  if (!this.state.verificationCode.trim())
      errors.verificationCode = "code verification is required"; //

  if (!this.state.country.trim())
    errors.country = "Country is required";

  if (!this.state.password.trim()) {
    errors.password = "Password is required";
  } else {
    if (this.state.password.length < 8)
      errors.password = "Minimum 8 characters";

    if (!/[A-Z]/.test(this.state.password))
      errors.password = "Must contain one uppercase";

    if (!/[a-z]/.test(this.state.password))
      errors.password = "Must contain one lowercase";

    if (!/[0-9]/.test(this.state.password))
      errors.password = "Must contain one number";
  }

  this.setState({ errors });

  return Object.keys(errors).length === 0;
};



//----------------------------------
//----------------------------------

  /*handleResend = async (username) => {
  try {
    const { destination, deliveryMedium } = await resendSignUpCode({ username });
    console.log(`Code sent to ${destination} via ${deliveryMedium}`);

  } catch (err) {
    console.error("Error resending code:", err);
  }
}*/


handleResend  = async (username) => {

  try {
    const { CodeDeliveryDetails } = await Auth.resendSignUp(username);

    const { Destination, DeliveryMedium } = CodeDeliveryDetails;

    console.log(`Code sent to ${Destination} via ${DeliveryMedium}`);

  } catch (err) {
    console.error("Error resending code:", err);
  }
};


handleResendCode = async () => {

  try {
    await Auth.resendSignUp(this.state.email);
    alert("A new verification code has been sent to your email.");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }

};



resendCode = (username) => {


   const userPool = new CognitoUserPool({
      userPoolId: "us-west-2_OCsKhMAAK",
      userPoolWebClientId  : "3r8p8dskolorgad9e73hm7kli6"
   });

   this.user = new CognitoUser({
      Username: this.state.email,
      Pool: userPool
   });

    this.user.resendConfirmationCode((err, result) => {
        if (err) {
            console.log(err);
            alert(err.message);
            return;
        }

        alert("Verification code sent again!");
    });
};





//----------------------------------
//----------------------------------
 confirmCode = async event => {

 event.preventDefault();

  try {

    await Auth.confirmSignUp(
      this.state.email,
      this.state.verificationCode
    );

    //--------------------------------------------
        this.User_Access_API();  //
        //this.User_registration_DB();  //User_Access_API


        //this.props.history.push("/login"); 
    //--------------------------------------------
   

  } catch (err) {
    console.log(err);


    let errors = {};

    switch (err.code) {
      case "UsernameExistsException":
        errors.email = "This email already exists";
        break;

      case "InvalidPasswordException":
        errors.password = err.message;
        break;

      case "InvalidParameterException":
        errors.server = err.message;
        break;

      default:
        errors.server = err.message;
    }

    this.setState({ errors });

  }


}



/*async  getUserFromDynamo(userId) {

   const params = {
      TableName: "Users",

      Key: {
         username: userId
      }
   };

   try{
   const result = await docClient.get(params).promise();


      /*
      USER NOT FOUND
   */

 /*  if(
      !result.Item
   ){

      console.log(
         'User not found'
      );

      this.setState({

         loading:false,

         message:
            'User not found'

      });

      return;
   }

   /*
      SUCCESS
   */

  /* console.log(
      result.Item
   );

   this.setState({

      loading:false,

      userData:
         result.Item,

      message:
         'Success'

   });

}
catch(error){

   console.log(error);

   /*
      DYNAMODB ERROR
   */

   /*this.setState({

      loading:false,

      message:
         error.message

   });

}

   //return result.Item;
}*/



 async  checkTrial(req, res, next) {

   const userId = req.user.sub;

   const user = await this.getUserFromDynamo(userId);

   if (!user) {

      return res.status(404).json({
         message: "User not found"
      });
   }

   if (Date.now() > new Date(user.trialEnd)) {

      return res.status(403).json({
         message: "Trial expired"
         //denyAccess();
      });
   }

   next();
}







/*A. New signup
{
  "username": "user@email.com",
  "status": "pending",
  "subscriptionType": "none",
  "paymentStatus": "unpaid"
}

Meaning:

Waiting for admin.

B. Approved + free trial
{
  "username": "user@email.com",
  "status": "approved",
  "subscriptionType": "freeTrial",
  "paymentStatus": "unpaid",
  "trialStart": "2026-06-30T00:00:00Z",
  "trialEnd": "2026-07-14T00:00:00Z"
}

Meaning:

Can use system.

C. Converted to paid
{
  "username": "user@email.com",
  "status": "approved",
  "subscriptionType": "paid",
  "paymentStatus": "paid",
  "membershipStart": "2026-07-14T00:00:00Z",
  "membershipEnd": "2026-08-14T00:00:00Z"
}

Meaning:

Active subscriber.

D. Subscription expired
{
  "username": "user@email.com",
  "status": "approved",
  "subscriptionType": "paid",
  "paymentStatus": "expired"
}

Meaning:

Account exists but access blocked.*/





async User_Access_API()  {


    var input = {

    username    : this.state.username,
    email       : this.state.email,
    firstname   : this.state.firstName, 
    lastname    : this.state.lastName, 
    country     : this.state.country, 
    LinkedIn    : this.state.LinkedIn,
    experience  : this.state.experience,
    platform    : this.state.platform,
    style       : this.state.style,
    market      : this.state.preferences,
    betaReason  : this.state.betaReason,

    //status           : "pending",
    //subscriptionType : "none",
    //paymentStatus    : "unpaid",

  };


    try {
    const response = await fetch(
        "https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/create-profile",
        {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(input)
        }
    );

    // 🔥 Check HTTP status first
    if (!response.ok) {
        const errorText = await response.text(); // Lambda error message
        throw new Error(
        `HTTP Error ${response.status}: ${errorText}`
        );
    }

    const data = await response.json();

    console.log("SUCCESS:", data);

    // optional UI update
    // this.setState({ success: true });

    
                this.setState(
                {
                    step: 'pending'
                },
                () => {


                    //--------------------------
                    this.sendEmail() ;
                     //--------------------------

                });

    } catch (error) {
    console.error("API ERROR:", error.message);

    // optional UI feedback
    // this.setState({ error: error.message });
    }






    //https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta
    /*await fetch("https://jtt8y195dj.execute-api.us-west-2.amazonaws.com/beta/create-profile", {
    method: "POST",
    headers: {
    "Content-Type": "application/json"
    },
    body: JSON.stringify(input)
    });*/

//---------------------------------------------
 

  

}


sendEmail= async () => {


     const serviceId = "service_2il25pv";
     const templateId = "template_3vhha2c";

     const variables = {

        to_email  : String(this.state.email || ""),
        to_name   : String(this.state.username || ""),
        market    : String(this.state.market || ""),
        style     : String(this.state.style || ""),
        experience: String(this.state.experience || "")
    };

    const public_key = "m1pJwSAb0YsHunabH"  ;


    try {
        const response = await emailjs.send(
             serviceId     ,   // your service ID
             templateId,     // template ID from EmailJS
             variables,       // template params
             public_key  // 👈 public key here
        );

        console.log("Email successfully sent!", response.status, response.text);
        return response;

    } catch (error) {
        console.error("Email sending failed:", error);
        throw error;
    }
};




/*async User_registration_DB()  {


  var input = {

    username    : this.state.username,
    email       : this.state.email, 
    firstname   : this.state.firstName, 
    lastname    : this.state.lastName, 
    country     : this.state.country, 
    LinkedIn    : this.state.LinkedIn,
    experience  : this.state.experience,
    platform    : this.state.platform,
    style       : this.state.style,
    market      : this.state.preferences,
    betaReason  : this.state.betaReason,



  };
  
  var params = {
        TableName: "idms-aws-db",
        Item:  input
  };


  var error = false;

  docClient.put(params, function (err, data) {

       
  
        if (err) {
            console.log("users::save::error - " + JSON.stringify(err, null, 2));       
             error = true ;               
        } else {

            console.log("users::save::success" );  
            error = false ;
        }
    });


    if(error == false )  {

        //------------------------------------------------
                //Built-in Feedback Center
        //------------------------------------------------

                this.setState(
                {
                    step: 'pending'
                },
                () => {

                    //console.log(this.state.step);

                });

            //this.setState({ step: "signup" });

            //window.location = "http://idms-streaming-filali.com.s3-website-us-west-2.amazonaws.com/";    
            //window.open("http://idms-venture-filali.com.s3-website-us-west-2.amazonaws.com/","_blank");

             //this.props.history.push("/login"); 
    }



}*/



   handleClick(e) {    
    e.preventDefault();    
    //window.location = "http://idms-streaming-filali.com.s3-website-us-west-2.amazonaws.com/";    
    window.open("http://idms-venture-filali.com.s3-website-us-west-2.amazonaws.com/","_blank");
  }


  sendFeedback = async () => {

    const templateId = "template_3vhha2c";

    const variables = {
        to_email: String("zahra.dayhome@hotmail.com" || ""),
        to_name: String("idms_zahra" || ""),
        market: String("crypto" || ""),
        style: String("swing" || ""),
        experience: String("more than 10 years" || "")
    };


    try {
        const response = await emailjs.send(
            "service_2il25pv",        // your service ID
            templateId,     // template ID from EmailJS
            variables,       // template params
            "m1pJwSAb0YsHunabH"   // 👈 public key here
        );

        console.log("Email successfully sent!", response.status, response.text);
        return response;

    } catch (error) {
        console.error("Email sending failed:", error);
        throw error;
    }
};


  
componentDidMount() {


    this.setState(
    {
        step: 'signup'
    },
    () => {

        //console.log(this.state.step);

    });



}


handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    // Correctly update nested objects in class state
    this.setState((prevState) => ({
      preferences: {
        ...prevState.preferences,
        [name]: checked
      }
    }));
  };


handleInputChange = (e) => {
  const { name, value } = e.target;

  console.log("STATE:", this.state);
  console.log("EVENT:", e.target.name, e.target.value);

  this.setState((prevState) => ({
    [name]: value,
    errors: {
      ...(prevState.errors || {}),
      [name]: ""
    }
  }));
};


//just sent to  {"    " + this.state.email}


//To finish signing in, enter the code from your email mailbox

render() {

    const { Forex, Indices, Commodities, Stocks, CFDs, Cryptocurrency} = this.state.preferences;
  
  return (
    <AbsoluteWrapper>

      {this.state.step === 'signup' && (

          <section className="row justify-content-center text-center p-5">
            <article className="col-md-8">
              <div className="card p-1 m-1 shadow">
                <div className="card-body">
                  
                   <img src="./pictures/images_30.jpg" width="50%"  height="200px" ></img>

                   <br></br>
                   <br></br>
                   <br></br>

                  <h3  style = {{color: 'rgb(43, 97, 245)'}}  >Request a Personalized Demo</h3>
                      <br></br>
                    <a style =  {{color: 'rgb(25, 36, 65)'  ,  fontSize: '20px' , display: 'block'}}  >Review the iDMS business model, methodology, competitive advantages, and cloud-based trading intelligence platform capabilities.</a>

                    <br></br>

                     <div className="navbar-brand "  id="inline1">
                       <a className="navbar-item" href="/">
                          < img src="logo.png" width="140" height="32" alt="idms logo" />
                       </a>
                    </div>

                   <div className="wrapper-line-login"></div>
                  
                </div>
              </div>
            </article>
          </section>

      )}


    {this.state.step === 'signup' && (

        <section className="row justify-content-center text-center p-5">
          <article className="col-md-6">
            <div className="card p-1 m-1 shadow">


               <div className="card-body">
                
                    <h5 style = {{color: 'rgb(0, 0, 0)' , textAlign: 'left'}}  >Research & Validation and Founding Participant Program : </h5>
                      <br></br>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left' ,  fontSize: '18px' , display: 'block'}}  >  Join a limited group of traders and receive 21-day temporary access helping evaluate and validate platform capabilities, workflows, and future development priorities.</a>
                      <br></br>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left' ,  fontSize: '18px' , display: 'block'}}  >  Participants are selected based on trading experience, platform fit, and their ability to provide constructive feedback.</a>


                    <div className="navbar-brand "  id="inline1">
                    </div>

                   <div className="wrapper-line-login"></div>

               </div>


               <div className="card-body">
                
                    <h5  style = {{color: 'rgb(0, 0, 0)' , textAlign: 'left'}}  >Approved high-skill Top contributors may receive :</h5>
                      <br></br>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left'  ,  fontSize: '18px' , display: 'block'}}  >✓ Early platform access </a>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left'  ,  fontSize: '18px' , display: 'block'}}  >✓ extended access </a>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left'  ,  fontSize: '18px' , display: 'block'}}  >✓ Direct communication with the product team</a>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left'  ,  fontSize: '18px' , display: 'block'}}  >✓ Opportunity to influence future platform development</a>
                    <a  style = {{color: 'rgb(25, 36, 65)' , textAlign: 'left'  ,  fontSize: '18px' , display: 'block'}}  >✓ Founding participant benefits upon commercial launchs</a>


                    <div className="navbar-brand "  id="inline1">
                    </div>

                   <div className="wrapper-line-login"></div>

               </div>





             </div>
         </article>
        </section>


            )}


                     {this.state.step === 'signup' && (


                            <section className="row justify-content-center text-center p-5">
                                    <article className="col-md-6">
                                      <div className="card p-1 m-1 shadow">
                                         <div className="card-body">

                                            <div className="access-form justify-content-center ">

                                                <h2>
                                                    Request Temporary Access
                                                </h2>

                                                <input
                                                    type="text"
                                                    name="firstName"
                                                    placeholder="First Name"
                                                    //onChange={(e) => this.setState({ firstName: e.target.value })}

                                                    value={this.state.firstName}
                                                    onChange={this.handleInputChange}

                                                    className="form-input"
                                                />

                                                {this.state.errors && this.state.errors.firstName && (
                                                <div className="error-message">
                                                    {this.state.errors.firstName}
                                                </div>
                                                )}

                                                

                                                <input
                                                    type="text"
                                                    placeholder="Last Name"
                                                    onChange={(e) => this.setState({ lastName: e.target.value })}
                                                    className="form-input"
                                                />

                                                {this.state.errors && this.state.errors.lastName && (
                                                <div className="error-message">
                                                    {this.state.errors.lastName}
                                                </div>
                                                )}

                                                <input
                                                    type="email"
                                                    placeholder="Email Address"
                                                    onChange={(e) => this.setState({ email: e.target.value })}
                                                    className="form-input"
                                                />

                                                {this.state.errors && this.state.errors.email && (
                                                <div className="error-message">
                                                    {this.state.errors.email}
                                                </div>
                                                )}

                                                
                                                <input
                                                    type="text"
                                                    placeholder="Country"
                                                    onChange={(e) => this.setState({ country: e.target.value })}
                                                    className="form-input"
                                                />

                                                 {this.state.errors && this.state.errors.country && (
                                                <div className="error-message">
                                                    {this.state.errors.country}
                                                </div>
                                                )}

                                                <input
                                                        type="text"
                                                        name="username"
                                                        placeholder="Userename"
                                                        onChange={(e) => this.setState({ username: e.target.value })}
                                                        className="form-input"
                                                    />

                                                     {this.state.errors &&  this.state.errors.username && (
                                                    <div className="error-message">
                                                        {this.state.errors.username}
                                                    </div>
                                                    )}


                                                <input
                                                        type="password"
                                                        name="password"
                                                        placeholder="Password"
                                                        onChange={(e) => this.setState({ password: e.target.value })}
                                                       className="form-input"
                                                    />

                                                     {this.state.errors && this.state.errors.password && (
                                                     <div className="error-message">
                                                        {this.state.errors.password}
                                                     </div>
                                                     )}

                                                      <input
                                                        type="text"
                                                        name="LinkedIn"
                                                        placeholder="LinkedIn url (optional)"
                                                        onChange={(e) => this.setState({ LinkedIn: e.target.value })}
                                                       className="form-input"
                                                    />


                                                <div className="form-group  "  style = {{textAlign: 'left'}}>
                                                <label className="mb-2">Trading Experience : </label>

                                                <select
                                                    className="form-select"
                                                    value={this.state.experience}
                                                    onChange={(e) =>
                                                    this.setState({ experience: e.target.value })

                                                    }
                                                >
                                                    <option value=""  >  Select Experience : </option>
                                                    <option value="Less than 1 year">Less than 1 year</option>
                                                    <option value="1-3 years">1 - 3 years</option>
                                                    <option value="3-5 years">3 - 5 years</option>
                                                    <option value="5-10 years">5 - 10 years</option>
                                                    <option value="10+ years">10+ years</option>
                                                </select>

                                                {this.state.errors && this.state.errors.experience && (
                                                        <div className="error-message">
                                                            {this.state.errors.experience}
                                                        </div>
                                                    )}

                                                </div>


                                                <div className="form-group" style = {{textAlign: 'left'}}>
                                                <label >Which platform do you primarily use ? </label>

                                                <select
                                                    className="form-select"
                                                    value={this.state.platform}
                                                    onChange={(e) =>
                                                        this.setState({ platform: e.target.value })
                                                    }
                                                >
                                                    <option value="" style = {{textAlign: 'left', width: '100%'}}>Select Platform</option>
                                                    <option value="MT5">MT5</option>
                                                    <option value="MT4">MT4</option>
                                                    <option value="MT4-MT5">MT4 & MT5</option>
                                                    <option value="IBKR">IBKR - Interactive Brokers</option>
                                                    <option value="NDAX">NDAX</option>
                                                    
                                                    <option value="Other">Other</option>
                                                </select>

                                                {this.state.errors &&  this.state.errors.platform && (
                                                        <div className="error-message">
                                                            {this.state.errors.platform}
                                                        </div>
                                                    )}

                                                </div>

                                                <div className="form-group" style = {{textAlign: 'left'}}>
                                                <label >Which best describes your trading approach ? </label>

                                                <select
                                                    className="form-select"
                                                    value={this.state.style}
                                                    onChange={(e) =>
                                                        this.setState({ style: e.target.value })
                                                    }
                                                >
                                                    <option value="" style = {{textAlign: 'left', width: '100%'}}>Select Trading Style</option>
                                                    <option value="MT">Manual trading</option>
                                                    <option value="SA">Semi-automated</option>
                                                    <option value="FA">Fully automated</option>
                                                    <option value="QS">Quantitative/Systematic</option> 
                                                </select>

                                                    {this.state.errors &&  this.state.errors.style && (
                                                        <div className="error-message">
                                                            {this.state.errors.style}
                                                        </div>
                                                    )}

                                                </div>

                                            

                                                <div className="form-group" style = {{textAlign: 'left'}}>
                                                     <label >Market Traded : </label>
                                                       <br />
                                                    
                                                    <label>
                                                    <input
                                                        type="checkbox"
                                                        name="Forex"
                                                        checked={Forex}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; Forex
                                                    </label>
                                                    <br />

                                                    <label>
                                                    <input
                                                        type="checkbox"
                                                        name="Indices"
                                                        checked={Indices}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; Indices
                                                    </label>
                                                    <br />

                                                    <label>
                                                    <input
                                                        type="checkbox"
                                                        name="Commodities"
                                                        checked={Commodities}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; Commodities
                                                    </label>

                                                     <br />

                                                    <label>
                                                    <input
                                                        type="checkbox"
                                                        name="Stocks"
                                                        checked={Stocks}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; Stocks
                                                    </label>

                                                     <br />

                                                     
                                                    <label>
                                                    <input
                                                        type="checkbox"
                                                        name="CFDs"
                                                        checked={CFDs}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; CFDs
                                                    </label>

                                                     <br />



                                                    <label>

                                                    <input
                                                        type="checkbox"
                                                        name="Cryptocurrency"
                                                        checked={Cryptocurrency}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                     &nbsp; Cryptocurrency
                                                    </label>


                                                    {this.state.errors &&  this.state.errors.preferences && (
                                                        <div className="error-message">
                                                            {this.state.errors.preferences}
                                                        </div>
                                                    )}

                                                </div>





                                                <div className="form-group mt-3 text-start">

                                                    <label className="mb-2">
                                                        Why would you like to participate in the beta?
                                                    </label>

                                                    <textarea
                                                        rows="4"
                                                        placeholder="Tell us about your trading experience, interests, and what type of feedback you would like to provide."
                                                        value={this.state.betaReason}
                                                        onChange={(e) =>
                                                            this.setState({ betaReason: e.target.value })
                                                        }
                                                        className="form-input"
                                                    />


                                                    
                                                    {this.state.errors &&  this.state.errors.betaReason && (
                                                        <div className="error-message">
                                                            {this.state.errors.betaReason}
                                                        </div>
                                                    )}


                                                    

                                                </div>

                                               
                                                {/* GLOBAL SERVER ERROR */}
                                                {this.state.errors &&  this.state.errors.server && (
                                                    <div className="global-error">
                                                        {this.state.errors.server}
                                                    </div>
                                                )}


                                                <button   onClick={() => this.requestAccess()}>

                                                    Request for Early  Access

                                                </button>

                                                <br></br>
                                                  <a className="btn btn-link" href="http://app.idms-invest.com.s3-website-us-west-2.amazonaws.com/" target="_blank" rel="noopener noreferrer">Already a member? Click here to log in</a>
                                                <br></br>

                                                 <a  style = {{color: 'rgb(7, 228, 248)' , textAlign: 'left', fontSize: '10px'}}  >Applications are reviewed based on trading experience, platform fit, and the ability to provide constructive feedback.</a>
                                                 <a  style = {{color: 'rgb(7, 228, 248)' , textAlign: 'left', fontSize: '10px'}}  >Approved participants will receive onboarding instructions and temporary platform access by email.</a>

                                                       
                                            </div>
                                     </div>
                                  </div>
                              </article>
                        </section>

                               )}



                    {this.state.step === 'verify' && (


                            <section className="row justify-content-center text-center p-5">
                                    <article className="col-md-6">
                                      <div className="card p-1 m-1 shadow">
                                         <div className="card-body">

                                            <div className="access-form justify-content-center ">

                                                <a  style={ { size: '14px' } }>
                                                     To verify your account Check your mailbox Enter the verification code we just sent to  {"    " + this.state.email}
                                                </a>

                                                <br></br>

                                                <input
                                                    type="text"
                                                    placeholder="code"
                                                    onChange={(e) => this.setState({ verificationCode: e.target.value })}
                                                />

                                                 {this.state.errors &&  this.state.errors.verificationCode && (
                                                        <div className="error-message">
                                                            {this.state.errors.verificationCode}
                                                        </div>
                                                )}

                                                
                                                <br></br>
                                                <br></br>


                                                  {/* GLOBAL SERVER ERROR */}
                                                  {this.state.errors &&  this.state.errors.server && (
                                                    <div className="global-error">
                                                        {this.state.errors.server}
                                                    </div>
                                                  )}

                                                
                                                  <button id="myButton" width = "100px"   onClick={this.confirmCode}  className = "button_login_app" >Sign In to the application!</button>


                                                <br></br>

                                            </div>

                                            <div style={{ marginTop: "15px" }}>

                                                   <a
                                                      href="#"
                                                      onClick={this.handleResendCode}
                                                      style={{
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                            color: "#007bff",
                                                            textDecoration: "underline"
                                                      }}
                                                   >
                                                      Didn’t receive the code? Resend it
                                                   </a>
                                            </div>

                                     </div>
                                  </div>
                              </article>
                        </section>

                               )}









                                 {this.state.step === 'pending' && (

                                   

                                    <section className="row justify-content-center text-center p-5">


                                    <article className="col-md-6">
                                      <div className="card p-1 m-1 shadow">
                                         <div className="card-body">

                                            <div className="access-form justify-content-center ">

   

                                                    <h4  style = {{color: 'rgb(230, 245, 244)'    , textAlign: 'left'}}  >Application Submitted :</h4>  

                                                    <br></br>
                                                    <a style = {{color: 'rgb(245, 230, 230)' , textAlign: 'left'}}  >Thank you for your interest in the iDMS Founding Participant Program.</a>
                                                    <a style = {{color: 'rgb(245, 230, 230)' , textAlign: 'left'}}  >Email has been just sent to {"    "}  {this.state.email}  {"  "}  for your record.</a>
                                                    <a  style = {{color: 'rgb(245, 230, 230)' , textAlign: 'left' ,  fontSize: '16px'}}  >If selected, you will receive onboarding instructions and access details by email.</a>

                                                    <br></br>
                                                    <a  style = {{color: 'rgb(245, 230, 230)' , textAlign: 'left' ,  fontSize: '16px'}} >Status: Pending Review !</a>


                                            </div>
                                     </div>
                                  </div>
                              </article>
                        </section>

                          )}



                    {this.state.step === 'feedback' && (

                          <div className="card p-3 shadow">
                            <div className="card-body-feedback">

                                <h2 className="feedback-title">
                                    Feedback Center
                                </h2>

                                <p className="feedback-subtitle">
                                    Help us improve the platform by sharing your feedback.
                                </p>

                                <div className="form-group mb-3">
                                    <label className="feedback-label">
                                        Feedback Category
                                    </label>

                                    <select
                                        className="feedback-select"
                                        value={this.state.feedbackCategory}
                                        onChange={(e) =>
                                            this.setState({
                                                feedbackCategory: e.target.value
                                            })
                                        }
                                    >
                                        <option value="">Select Category</option>
                                        <option value="UI Issue">UI Issue</option>
                                        <option value="Signal Quality">Signal Quality</option>
                                        <option value="Alerts">Alerts</option>
                                        <option value="Performance">Performance</option>
                                        <option value="Trading Dashboard">
                                            Trading Dashboard
                                        </option>
                                        <option value="Feature Request">
                                            Feature Request
                                        </option>
                                        <option value="Bug Report">
                                            Bug Report
                                        </option>
                                        <option value="Other">
                                            Other
                                        </option>
                                    </select>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="feedback-label">
                                        Message
                                    </label>

                                    <textarea
                                        rows="6"
                                        className="feedback-textarea"
                                        placeholder="Describe your feedback, issue, suggestion, or feature request..."
                                        value={this.state.feedbackMessage}
                                        onChange={(e) =>
                                            this.setState({
                                                feedbackMessage: e.target.value
                                            })
                                        }
                                    />
                                </div>

                                <button
                                    className="feedback-btn"
                                    onClick={this.submitFeedback}
                                >
                                    Submit Feedback
                                </button>

                            </div>
                        </div>

                           )}





    </AbsoluteWrapper>



  );
};
};



export default PageThree;
